module.exports = __webpack_public_path__ + "static/media/apple.189b86c9.svg";